(function () {
  "use strict";

  function isProductBlockVisible(productBlock) {
    const classes = productBlock.className;
    const isMobile = window.innerWidth < 768;
    const isDesktop = window.innerWidth >= 768;

    const hasHidden = classes.includes("hidden");
    const hasBlock = classes.includes("block");
    const hasMdBlock = classes.includes("md:block");
    const hasMdHidden = classes.includes("md:hidden");

    if (isDesktop && hasHidden && hasMdBlock) {
      return true;
    }

    if (isMobile && hasBlock && hasMdHidden) {
      return true;
    }

    if (isDesktop && hasBlock && hasMdHidden) {
      return false;
    }

    if (isMobile && hasHidden && hasMdBlock) {
      return false;
    }

    const blockStyle = window.getComputedStyle(productBlock);
    const blockRect = productBlock.getBoundingClientRect();
    return blockStyle.display !== "none" && blockRect.width > 0 && blockRect.height > 0;
  }

  function removeHiddenElements(selector) {
    const allElements = document.querySelectorAll(selector);
    const removedElements = [];
    const parentElements = new Map();

    allElements.forEach((element) => {
      const productBlock = element.closest(".product__block");

      if (productBlock) {
        const isVisible = isProductBlockVisible(productBlock);

        if (!isVisible) {
          parentElements.set(element, {
            parent: productBlock,
            nextSibling: element.nextSibling,
          });

          element.remove();
          removedElements.push(element);
        }
      }
    });

    function restore() {
      removedElements.forEach((element) => {
        const parentInfo = parentElements.get(element);
        if (parentInfo && parentInfo.parent) {
          if (parentInfo.nextSibling && parentInfo.nextSibling.parentNode) {
            parentInfo.parent.insertBefore(element, parentInfo.nextSibling);
          } else {
            parentInfo.parent.appendChild(element);
          }
        }
      });
    }

    return {
      restore,
      removedElements,
      parentElements,
    };
  }

  function setupRemoveGuard(selector, options = {}) {
    const { delay = 0, onReady } = options;
    let restoreFunction = null;
    let removedElements = [];
    let parentElements = new Map();
    let cleanupFunction = null;

    function applyGuard() {
      const result = removeHiddenElements(selector);
      restoreFunction = result.restore;
      removedElements = result.removedElements || [];
      parentElements = result.parentElements || new Map();

      if (onReady) {
        onReady(selector);
      }

      cleanupFunction = () => {
        if (restoreFunction) {
          restoreFunction();
          restoreFunction = null;
        }
        removedElements = [];
        parentElements.clear();
      };
    }

    if (delay > 0) {
      setTimeout(applyGuard, delay);
    } else if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyGuard);
    } else {
      applyGuard();
    }

    return () => {
      if (cleanupFunction) {
        cleanupFunction();
      }
    };
  }

  function setupWidgetSelectorGuard(selector, options = {}) {
    const { delay = 0, onInit } = options;
    const selectors = Array.isArray(selector) ? selector : [selector];
    return setupRemoveGuard(selectors[0], { delay, onReady: onInit });
  }

  function autoInit() {
    const commonSelectors = ["#looxReviews", ".loox-reviews-default"];

    commonSelectors.forEach((selector) => {
      if (document.querySelector(selector)) {
        setupWidgetSelectorGuard(selector, { delay: 200 });
      }
    });

    document.querySelectorAll("[data-widget-guard]").forEach((element) => {
      const selector = element.getAttribute("data-widget-guard");
      const delay = parseInt(element.getAttribute("data-widget-guard-delay") || "200", 10);
      if (selector) {
        setupWidgetSelectorGuard(selector, { delay });
      }
    });
  }

  window.WidgetSelectorGuard = {
    setup: setupWidgetSelectorGuard,
    init: autoInit,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoInit);
  } else {
    autoInit();
  }
})();
